export default import.meta.ROLLDOWN_FILE_URL_X4e0K3lWu31WoqFRl$w6gw